import { PageLocatorMap } from '../types/PageLocatorMap';

export const applyPage = {
  footer: {
    root: 'apply-page.footer.root',
  },
  form: {
    h1: 'apply-page.form.h1',
    h2: 'apply-page.form.h2',
    root: 'apply-page.form.root',
    submitButton: 'apply-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
